import {FETCH_COUPONS_DATA } from '../actions/actiontypes';

export default function (state = {}, action) {
    switch (action.type) {
        case FETCH_COUPONS_DATA: {
            return { ...state, couponsData: [...action.payload ] };
        }
        default:
            return state;
    }
}